import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import formatCurrency from 'modules/core/lib/formatCurrency'
import { currencyToNumber } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

export interface IStatCard {
  totalAmount: number
  employeeCount: number
  sizeSmaller?: boolean
}

const StatsCard = ({ totalAmount, employeeCount, sizeSmaller }: IStatCard) => {
  const totalAmountFormatted = formatCurrency(currencyToNumber(totalAmount))

  return (
    <Box flexDirection="row" alignItems="flexEnd">
      <Box
        flexDirection="row"
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
      >
        {sizeSmaller ? (
          <>
            <Box
              padding="s16"
              paddingX="s32"
              minWidth="s140"
              justifyContent="center"
              alignItems="center"
              gap="s2"
            >
              <Text.Normal size="200">
                {i18n.t('payroll_bundle.results_payments.payments.generate_payment.total_amount')}
              </Text.Normal>
              <Text.Header2>{totalAmountFormatted}</Text.Header2>
            </Box>
            <Box
              padding="s16"
              paddingX="s32"
              minWidth="s140"
              justifyContent="center"
              alignItems="center"
              gap="s2"
              border={{
                left: {
                  color: 'grey400',
                  width: 's1',
                  style: 'solid',
                },
              }}
            >
              <Text.Normal size="200">
                {i18n.t('payroll_bundle.results_payments.payments.generate_payment.employee')}
              </Text.Normal>
              <Text.Header2>{employeeCount}</Text.Header2>
            </Box>
          </>
        ) : (
          <>
            <Box width="s240" height="s120" justifyContent="center" alignItems="center" gap="s2">
              <Text.Normal>
                {i18n.t('payroll_bundle.results_payments.payments.generate_payment.total_amount')}
              </Text.Normal>
              <Text.Header1>{totalAmountFormatted}</Text.Header1>
            </Box>
            <Box
              width="s240"
              height="s120"
              justifyContent="center"
              alignItems="center"
              gap="s2"
              border={{
                left: {
                  color: 'grey400',
                  width: 's1',
                  style: 'solid',
                },
              }}
            >
              <Text.Normal>
                {i18n.t('payroll_bundle.results_payments.payments.generate_payment.employee')}
              </Text.Normal>
              <Text.Header1>{employeeCount}</Text.Header1>
            </Box>
          </>
        )}
      </Box>
    </Box>
  )
}

export default observer(StatsCard)
